import React from 'react'
import Link from 'gatsby-link'
import Image from './image'
import logo from '../../../static/images/header-lovesong-logo.png'
import splash from '../../../static/images/home-splash-maui2019.jpg'

export default class OnLocationHeader extends React.Component {
  render() {
    const { trip, backTo, homeTo } = this.props

    return (
      <header
        className="onlocation"
        style={{ backgroundImage: `url(${splash})` }}
      >
        <div className="wrap">
          {backTo ? (
            <Link className="back" to={backTo} aria-label="Back">
              <i className="fa fa-angle-left" />
            </Link>
          ) : (
            ''
          )}
          {homeTo ? (
            <Link className="home" to={homeTo} aria-label="Home">
              <i className="fa fa-angle-left" />
              <span>Home</span>
            </Link>
          ) : (
            ''
          )}
          <Link to={`/${trip}/onlocation`} aria-label="Home">
            <Image src={logo} alt="Love Song" />
          </Link>
        </div>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/onlocation-header.js